import React, { Component } from 'react';
import { Dialog, Button, Intent } from '@blueprintjs/core';

class Modal extends Component {

  constructor(props) {
    super(props);

    this.state = {}

    this.save = this.save.bind(this);
    this.hide = this.hide.bind(this);

    this.iconName = null;
    this.title = null;
    this.saveButtonText = 'Speichern';
    this.saveButtonIcon = 'saved';
  }

  hide() {
    this.props.hide();
    this.state = this.initialState || {};
  }

  save() {
  }

  render() {
    return (
      <Dialog
        isOpen={this.props.show}
        onClose={this.hide}
        iconName={this.iconName}
        title={this.title}>
        <div className="pt-dialog-body">
          {this.renderBody()}
        </div>
        <div className="pt-dialog-footer">
          <div class="pt-callout pt-intent-danger">
            {this.state.inputError && this.state.inputError.text}
          </div>
          <div className="pt-dialog-footer-actions">
            <Button onClick={this.hide}>Abbrechen</Button>
            {this.renderActions && this.renderActions()}
            <Button
              text={this.saveButtonText}
              iconName={this.saveButtonIcon}
              intent={Intent.PRIMARY}
              onClick={this.save} />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default Modal;



/** WEBPACK FOOTER **
 ** ./src/modals/Modal.js
 **/